module.exports = __webpack_public_path__ + "img/shenheshibai@3x.40f5c7a0.svg";